module.exports = __webpack_public_path__ + "static/img/sumr97.83c703a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/conversion/testimonial/sumr97.png
// module id = JHn3
// module chunks = 35